"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.changeRecipePrivacyMutation = void 0;
const client_1 = require("@apollo/client");
exports.changeRecipePrivacyMutation = client_1.gql `
  mutation ChangeRecipePrivacy($id: String!, $unlisted: Boolean!) {
    changeRecipePrivacy(id: $id, unlisted: $unlisted) {
      __typename
      recipe {
        __typename
        id
        privacy
        shareId
      }
    }
  }
`;
//# sourceMappingURL=ChangeRecipePrivacy.js.map